import UserMail from '@/generated/controls/user/UserMail.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: UserMail
})

